export default __webpack_public_path__ + "static/media/info.d7f882e5.svg";